import { values } from '@fortem-monorepo/js-utilities';
export const GUARANTOR = {
    GoldmanSachsGroup: 'Goldman Sachs Group, Inc.',
    MorganStanley: 'Morgan Stanley',
    CitigroupGlobalMarkets: 'Citigroup Global Markets Limited',
    CanadianImperialBankOfCommerce: 'Canadian Imperial Bank of Commerce',
    GoldmanSachsInternational: 'Goldman Sachs International',
};
export const GUARANTORS = values(GUARANTOR);
